/**
 * 基本参考库（转接/替代以前的 web-common）
 */
(function (global, factory) {
    var theExports = null;
    var hasModuleExports = false;
    if(typeof module === "object" && typeof module.exports === "object") {
        theExports = module.exports;
        hasModuleExports = true;
    } else {//导出为模块
        theExports = global['App_Base'] = {};
    }
    factory(theExports, hasModuleExports);
}(typeof window !== "undefined" ? window : this, function (exports, hasModuleExports) {
    exports.__name__ = 'App_Base';
    //
    if(hasModuleExports) {
        console && console.log('以模块方式导入[' + exports.__name__ + ']');
    }
    else {
        console && console.log('以普通方式引入[' + exports.__name__ + ']');
    }
    //---------------------------------------------------------------------------------
    //...
    //----------------------------------- exports -------------------------------------
    exports.Store = window['store'] || undefined //require('store');

    exports.EventBus = window['EventBus'] || undefined //require('web-common/dist/eventbus');

    exports.Utils = window['Utils'] || require('web-common/dist/utils');

    exports.$ = window['jQuery'] || require('jquery');

    exports.Ajax = window['Ajax'] || require('web-common/dist/ajax');

    exports.Jqext = window['Jqext'] || require('web-common/dist/jquery.ext');

    exports.H5file = window['H5file'] || require('web-common/dist/h5file');
}));



//////////////////
// WEBPACK FOOTER
// ./src/app.base.js
// module id = 1
// module chunks = 0